import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { NakedButton } from '@frontend/design-system';

const styles = {
  linkButton: css`
    color: ${theme.colors.primary50};
    font-weight: ${theme.font.weight.bold};
    font-size: ${theme.font.size.large};
  `,
};

type SkipButtonProps = {
  onSkip?: () => void;
  id?: string;
};

export function SkipButton({ onSkip, id }: SkipButtonProps) {
  const { t } = useTranslation('account');

  const onClick = () => {
    onSkip?.();
  };

  return (
    <div
      css={css`
        text-align: center;
        margin: ${theme.spacing(6)} 0;
      `}
    >
      <NakedButton id={id} css={styles.linkButton} onClick={onClick}>
        {t('Skip and enable later')}
      </NakedButton>
    </div>
  );
}
